// Testi in italiano. Nei testi "rich" i tag <b>, <i>, <hl> vengono resi dal componente.
import legal from "./legal/it";
import home from "./home/it";

const it = {
  meta: {
    description:
      "Qapex: Trasformazione digitale, automazione, innovazione. Sviluppiamo soluzioni software personalizzate per far crescere il tuo business.",
  },


  contactForm: {
    // chiave = valore inviato al backend, valore = etichetta mostrata
    options: {
      "QA Service Provider": "QA Service Provider",
      "QA Consulting": "QA Consulting",
      "QUACK": "QUACK",
      "SubQ": "SubQ",
      "Sviluppo Custom": "Sviluppo software custom",
    },
    sending: "Invio...",
    submit: "INVIA",
    success: "Messaggio inviato! Ti ricontatteremo al più presto.",
    error: "Errore nell'invio. Riprova.",
    privacy: "Dichiaro di aver letto l'informativa sulla <link>Privacy Policy</link> e acconsento al trattamento dei miei dati per gestire la presente richiesta.",
  },

  workWithUs: {
    eyebrow: "Lavora con noi",
    heroTitle: "Entra a far parte del",
    heroHighlight: "nostro team.",
    heroText: "Plasma il futuro della qualità e dell'innovazione digitale con noi.",
    openPositions: "Posizioni aperte",
    apply: "Candidati",
    applyNow: "Candidati ora",
    // id = valore inviato nella candidatura
    positions: [
      {
        id: "Software Tester",
        title: "Software Tester",
        description:
          "Cerchiamo un Software Tester attento ai dettagli. Sarai responsabile dell'esecuzione dei casi di test, del tracciamento dei bug e di garantire la massima qualità dei nostri prodotti software. È richiesta esperienza con i test manuali; l'automazione è un plus.",
      },
      {
        id: "QA Engineer",
        title: "QA Engineer",
        description:
          "Unisciti a noi come QA Engineer per progettare e implementare strategie di test. Dovresti essere competente negli strumenti di test automatizzati, nelle pipeline CI/CD e avere una forte comprensione del ciclo di vita dello sviluppo software.",
      },
      {
        id: "Full Stack Developer",
        title: "Full Stack Developer",
        description:
          "Cerchiamo uno Sviluppatore Full Stack per costruire applicazioni web scalabili. È essenziale la competenza in React, Node.js e nelle moderne tecnologie di database. Lavorerai a stretto contatto con i nostri team di design e QA per offrire esperienze utente eccezionali.",
      },
      {
        id: "Partner Commerciale",
        title: "Partner Commerciale",
        description:
          "QAPEX SRL cerca un Procacciatore Commerciale – Lead qualificati forniti\nCerchiamo un procacciatore commerciale autonomo per sviluppare nuove opportunità B2B.\nLa differenza rispetto alla classica attività commerciale? I lead li forniamo noi.\nMettiamo a disposizione una lista di aziende già selezionate e qualificate, permettendoti di concentrare il tuo tempo sull'attività commerciale: contatto, relazione, trattativa e chiusura.",
      },
    ],
  },

  applyModal: {
    title: "Candidati Ora",
    close: "Chiudi",
    fullName: "Nome Completo",
    namePlaceholder: "Mario Rossi",
    position: "Posizione",
    selectPosition: "Seleziona una posizione",
    email: "Indirizzo Email",
    emailPlaceholder: "mario@example.com",
    uploadCv: "Carica Curriculum",
    uploadCvHint: "Clicca per caricare il CV",
    privacy: "Accetto la <link>Privacy Policy</link> e acconsento al trattamento dei miei dati personali.",
    submitting: "INVIO IN CORSO...",
    submit: "INVIA CANDIDATURA",
    autoresponse: "Abbiamo ricevuto la tua candidatura e ti contatteremo a breve.",
    fileTooLarge: "Il file è troppo grande. Dimensione massima: 5MB.",
    fileTypeInvalid: "Tipo di file non supportato. Carica un PDF o un documento Word.",
    cvRequired: "Per favore carica il tuo curriculum.",
    privacyRequired: "Per favore accetta la privacy policy.",
  },

  legal,
  home,
};

export default it;
